import React from "react";
import {
  Box,
  Button,
  Typography,
  Paper,
  IconButton,
  CircularProgress,
  styled,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

const StyledGridOverlay = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
  "& .ant-empty-img-1": {
    fill: theme.palette.mode === "light" ? "#aeb8c2" : "#262626",
  },
  "& .ant-empty-img-2": {
    fill: theme.palette.mode === "light" ? "#f5f5f7" : "#595959",
  },
  "& .ant-empty-img-3": {
    fill: theme.palette.mode === "light" ? "#dce0e6" : "#434343",
  },
  "& .ant-empty-img-4": {
    fill: theme.palette.mode === "light" ? "#fff" : "#1c1c1c",
  },
  "& .ant-empty-img-5": {
    fillOpacity: theme.palette.mode === "light" ? "0.8" : "0.08",
    fill: theme.palette.mode === "light" ? "#f5f5f5" : "#fff",
  },
}));

function CustomNoRowsOverlay() {
  return (
    <StyledGridOverlay>
      <Box sx={{ mt: 1 }}>No Qualification Found</Box>
    </StyledGridOverlay>
  );
}

const QualificationDetails = ({
  qualificationList = [],
  loading = false,
  onAddQualification,
  onEditQualification,
  onDeleteQualification,
}) => {
  console.log("QualificationDetails Props:", qualificationList);

  const columns = [
    {
      field: "highest_qualification_name",
      headerName: "Highest Qualification",
      width: 180,
      renderCell: (params) => (
        <div>{params.row?.highest_qualification_name}</div>
      ),
    },
    {
      field: "qualification_name",
      headerName: "Qualification",
      width: 160,
      renderCell: (params) => <div>{params.row?.qualification_name}</div>,
    },
    {
      field: "stream_name",
      headerName: "Stream",
      width: 150,
      renderCell: (params) => <div>{params.row?.stream_name}</div>,
    },
    {
      field: "country_name",
      headerName: "Country",
      width: 150,
      renderCell: (params) => <div>{params.row?.country_name}</div>,
    },
    {
      field: "state_name",
      headerName: "State",
      width: 150,
      renderCell: (params) => <div>{params.row?.state_name}</div>,
    },
    {
      field: "affiliation_name",
      headerName: "Affiliation",
      width: 180,
      renderCell: (params) => <div>{params.row?.affiliation_name}</div>,
    },
    {
      field: "institution_name",
      headerName: "Institution",
      width: 220,
      renderCell: (params) => (
        <div style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>
          {params.row?.institution_name}
        </div>
      ),
    },
    {
      field: "education_status",
      headerName: "Status",
      width: 130,
      renderCell: (params) => <div>{params.row?.education_status}</div>,
    },
    {
      field: "year_of_passing",
      headerName: "Year",
      width: 100,
      renderCell: (params) => <div>{params.row?.year_of_passing || "-"}</div>,
    },
    {
      field: "action",
      headerName: "Action",
      width: 120,
      align: "center",
      headerAlign: "center",
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          <IconButton
            color="primary"
            onClick={() => onEditQualification(params.row)}
          >
            <EditIcon />
          </IconButton>

          <IconButton
            color="error"
            onClick={() => onDeleteQualification(params.row.id)}
          >
            <DeleteIcon />
          </IconButton>
        </>
      ),
    },
  ];

  const autoHeight = "200px";

  return (
    <Paper elevation={0}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography variant="h5" fontWeight={700}>
          Qualification Details
        </Typography>

        <Button
          variant="contained"
          color="secondary"
          onClick={onAddQualification}
        >
          Add Qualification
        </Button>
      </Box>

      <div style={{ width: "100%", marginTop: "10px" }}>
        {loading ? (
          <Box
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100px",
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <DataGrid
            rows={qualificationList}
            columns={columns}
            slots={{
              noRowsOverlay: CustomNoRowsOverlay,
            }}
            autoHeight={qualificationList.length === 0 && autoHeight}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 25,
                },
              },
            }}
            sx={{ marginTop: "20px" }}
            pageSizeOptions={[25, 50, 100]}
          />
        )}
      </div>
    </Paper>
  );
};

export default QualificationDetails;
